<app-loader *ngIf="isLoading()"></app-loader>

<div [ngClass]="{'d-none': isLoading()}" class="container container-profile container-profile-company">

  <!-- cover -->
  <div class="container-fluid container-cover-wrapper">
    <div class="container-cover">
      <div class="ovaalcontainer2">
        <div class="row">
          <div class="cover-photo" [ngStyle]="{'background-image': 'url(' + entity.coverPhotoUri + ')'}">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <div class="container-fluid container-content">

    <div class="content-wrapper">

      <div class="row">

        <div class="sidebar sidebar-left col-12 col-sm-3">

          <div class="content">

            <div class="card mb-3">

              <div class="card-body">

                <div class="company-logo">
                  <div class="circle">
                    <img class="image logo-image" [src]="entity.avatarUri ? entity.avatarUri : avatarPlaceholder" />
                  </div>
                </div>

                <div class="company-info">

                  <div class="h2 company-name">
                    {{entity.name}}
                  </div>

                  <div *ngIf="entity.city" class="location text-center mb-3">
                    <fa-icon [icon]="faMapMarkerAlt"></fa-icon> {{entity.city}}
                  </div>

                  <div class="company-sector" *ngIf="entity.sectorId">
                    <p>
                      <span class="text-primary">{{'Sector' | translate}}:</span>
                      <br>
                      {{interestService.getAreaOfInterestName(entity.sectorId, areaOfInterests)}}
                    </p>
                  </div>

                  <div class="company-areaofinterests" *ngIf="entity.areaOfInterests.length > 0">
                    <p>
                      <span class="text-primary">{{'Field of interest' | translate}}:</span>
                      <br>
                      <span *ngFor="let interest of entity.areaOfInterests; let key = index">
                        {{interestService.getAreaOfInterestName(interest.id, areaOfInterests)}}{{(key == entity.areaOfInterests.length - 1) ? '' : ','}}
                      </span>
                    </p>
                  </div>

                  <div class="company-employees" *ngIf="entity.numberOfEmployees">
                    <p>
                      <span class="text-primary">{{'Employees' | translate}}:</span>
                      <br>
                      {{entity.numberOfEmployees}}
                    </p>
                  </div>

                  <div class="company-employees" *ngIf="entity.currentUserMatchPercentage">
                    <p>
                      <span class="text-primary">{{'Match' | translate}}:</span>
                      <br>
                      {{entity.currentUserMatchPercentage}}%
                    </p>
                  </div>

                </div>

              </div>

            </div>

            <!-- network -->
            <div class="card mb-3" *ngIf="userService.currentUserHasRole(RoleTypes.Student)">

              <div class="card-body">
                <button [disabled]="isProcessing" *ngIf="!entity.isCurrentUserConnected" (click)="addCompanyConnection()" class="btn btn-outline-primary btn-block mb-2">
                  <fa-icon [icon]="faLink"></fa-icon> {{'Connect' | translate}}
                </button>
                <button [disabled]="isProcessing" *ngIf="entity.isCurrentUserConnected" (click)="deleteCompanyConnection()" class="btn btn-outline-primary btn-block mb-2">
                  <fa-icon [icon]="faUnlink"></fa-icon> {{'Disconnect' | translate}}
                </button>
                <button [disabled]="isProcessing" (click)="openCompanyApplicationModal()" class="btn btn-primary btn-block">
                  <fa-icon [icon]="faPaperPlane"></fa-icon> {{'Apply to company' | translate}}
                </button>
              </div>

            </div>

            <!-- navigation -->
            <div class="card">

              <div class="card-body p-0">

                <ul class="nav flex-column">
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'story'" (click)="selectTab('story')">
                      {{'Story' | translate}}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'jobs'" (click)="selectTab('jobs')">
                      {{'Jobs / Internships' | translate}}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'assignments'" (click)="selectTab('assignments')">
                      {{'Assignments' | translate}}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'experienceday'" (click)="selectTab('experienceday')">
                      {{'Follow-up days' | translate}}
                    </a>
                  </li>

                  <li class="nav-item" *ngIf="companyTrademarks.length > 0">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'trademarks'" (click)="selectTab('trademarks')">
                      {{'Trade names' | translate}}
                    </a>
                  </li>

                  <li class="nav-item" *ngIf="entity.isCurrentUserConnected">
                    <a class="nav-link cursor-pointer" [class.active]="activeTab === 'contact'" (click)="selectTab('contact')">
                      {{'Contact' | translate}}
                    </a>
                  </li>

                </ul>
              </div>

            </div>

            <div class="social-media mt-3 d-flex align-items-center justify-content-center">
              <ul class="social-media-links">
                <li class="social-media-item" *ngIf="entity.facebookUri">
                  <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="entity.facebookUri">
                    <fa-icon [icon]="faFacebookF"></fa-icon>
                  </a>
                </li>
                <li class="social-media-item" *ngIf="entity.instagramUri">
                  <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="entity.instagramUri">
                    <fa-icon [icon]="faInstagram"></fa-icon>
                  </a>
                </li>
                <li class="social-media-item" *ngIf="entity.twitterUri">
                  <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="entity.twitterUri">
                    <fa-icon [icon]="faXTwitter"></fa-icon>
                  </a>
                </li>
                <li class="social-media-item" *ngIf="entity.linkedInUri">
                  <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="entity.linkedInUri">
                    <fa-icon [icon]="faLinkedinIn"></fa-icon>
                  </a>
                </li>
                <li class="social-media-item" *ngIf="entity.googleUri">
                  <a class="social-media-icon-link btn-primary btn-icon btn-circle" target="_blank" [href]="entity.googleUri">
                    <fa-icon [icon]="faGoogle"></fa-icon>
                  </a>
                </li>

              </ul>
            </div>

          </div>

        </div>

        <div class="col-12 col-sm-9 main-content">

          <div class="tab-content">

            <div id="tab-profile-story" class="tab-pane" [class.active]="activeTab === 'story'" [class.d-none]="activeTab !== 'story'">

              <ul class="nav nav-pills">
                <li class="nav-item" *ngFor="let language of storyLanguages">
                  <a [ngClass]="{'active': activeStoryLanguage == language }" (click)="setActiveStoryLanguage(language)" class="nav-link cursor-pointer">
                    {{language}}
                  </a>
                </li>
              </ul>

              <div class="tab-content">

                <div id="tab-company-story-language-NL" class="tab-pane" [ngClass]="{'active': activeStoryLanguage == 'NL' }" [class.d-none]="activeStoryLanguage !== 'NL'">

                  <div class="company-description mb-3">
                    <h3>{{'About' | translate}} {{entity.name}}</h3>
                    <span class="ck-content" [innerHTML]="entity.description"></span>

                    <div class="clearfix"></div>

                    <button type="button" class="btn btn-outline-primary mt-3" (click)="toggleCompanyReadMore('NL')">
                      <span *ngIf="!companyReadMore.NL">{{'Read more' | translate}}</span>
                      <span *ngIf="companyReadMore.NL">{{'Read less' | translate}}</span>
                    </button>

                  </div>

                  <div id="company-read-more-nl" class="company-read-more" [class.d-none]="!companyReadMore.NL">

                    <div class="company-unique" *ngIf="entity.uniqueText">
                      <h3>{{'What makes us so unique?' | translate}}</h3>
                      <span class="ck-content" [innerHTML]="entity.uniqueText"></span>
                    </div>

                    <div class="company-opportunities" *ngIf="entity.opportunitiesText">
                      <h3>{{'Career possibilities' | translate}}</h3>
                      <span class="ck-content" [innerHTML]="entity.opportunitiesText"></span>
                    </div>

                  </div>

                </div>

                <div id="tab-company-story-language-EN" class="tab-pane" [ngClass]="{'active': activeStoryLanguage == 'EN' }" [class.d-none]="activeStoryLanguage !== 'EN'">

                  <div class="company-description mb-3">
                    <h3>{{'About' | translate}} {{entity.name}}</h3>
                    <span [innerHTML]="entity.descriptionEn"></span>

                    <div class="clearfix"></div>

                    <button type="button" class="btn btn-outline-primary mt-3" (click)="toggleCompanyReadMore('EN')">
                      <span *ngIf="!companyReadMore.EN">{{'Read more' | translate}}</span>
                      <span *ngIf="companyReadMore.EN">{{'Read less' | translate}}</span>
                    </button>

                  </div>

                  <div id="company-read-more-en" class="company-read-more" [class.d-none]="!companyReadMore.EN">

                    <div class="company-unique" *ngIf="entity.uniqueTextEn">
                      <h3>{{'What makes us so unique?' | translate}}</h3>
                      <span [innerHTML]="entity.uniqueTextEn"></span>
                    </div>

                    <div class="company-opportunities" *ngIf="entity.opportunitiesTextEn">
                      <h3>{{'Career possibilities' | translate}}</h3>
                      <span [innerHTML]="entity.opportunitiesTextEn"></span>
                    </div>

                  </div>

                </div>

                <div id="tab-company-story-language-DE" class="tab-pane" [ngClass]="{'active': activeStoryLanguage == 'DE' }" [class.d-none]="activeStoryLanguage !== 'DE'">

                  <div class="company-description mb-3">
                    <h3>{{'About' | translate}} {{entity.name}}</h3>
                    <span [innerHTML]="entity.descriptionDe"></span>

                    <div class="clearfix"></div>

                    <button type="button" class="btn btn-outline-primary mt-3" (click)="toggleCompanyReadMore('DE')">
                      <span *ngIf="!companyReadMore.DE">{{'Read more' | translate}}</span>
                      <span *ngIf="companyReadMore.DE">{{'Read less' | translate}}</span>
                    </button>

                  </div>

                  <div id="company-read-more-de" class="company-read-more" [class.d-none]="!companyReadMore.DE">

                    <div class="company-unique" *ngIf="entity.uniqueTextDe">
                      <h3>{{'What makes us so unique?' | translate}}</h3>
                      <span [innerHTML]="entity.uniqueTextDe"></span>
                    </div>

                    <div class="company-opportunities" *ngIf="entity.opportunitiesTextDe">
                      <h3>{{'Career possibilities' | translate}}</h3>
                      <span [innerHTML]="entity.opportunitiesTextDe"></span>
                    </div>

                  </div>

                </div>

                <div id="tab-company-story-language-FR" class="tab-pane" [ngClass]="{'active': activeStoryLanguage == 'FR' }" [class.d-none]="activeStoryLanguage !== 'FR'">

                  <div class="company-description mb-3">
                    <h3>{{'About' | translate}} {{entity.name}}</h3>
                    <span [innerHTML]="entity.descriptionFr"></span>

                    <div class="clearfix"></div>

                    <button type="button" class="btn btn-outline-primary mt-3" (click)="toggleCompanyReadMore('FR')">
                      <span *ngIf="!companyReadMore.FR">{{'Read more' | translate}}</span>
                      <span *ngIf="companyReadMore.FR">{{'Read less' | translate}}</span>
                    </button>

                  </div>

                  <div id="company-read-more-fr" class="company-read-more" [class.d-none]="!companyReadMore.FR">

                    <div class="company-unique" *ngIf="entity.uniqueTextFr">
                      <h3>{{'What makes us so unique?' | translate}}</h3>
                      <span [innerHTML]="entity.uniqueTextFr"></span>
                    </div>

                    <div class="company-opportunities" *ngIf="entity.opportunitiesTextFr">
                      <h3>{{'Career possibilities' | translate}}</h3>
                      <span [innerHTML]="entity.opportunitiesTextFr"></span>
                    </div>

                  </div>

                </div>

                <div id="tab-company-story-language-PT" class="tab-pane" [ngClass]="{'active': activeStoryLanguage == 'PT' }" [class.d-none]="activeStoryLanguage !== 'PT'">

                  <div class="company-description mb-3">
                    <h3>{{'About' | translate}} {{entity.name}}</h3>
                    <span [innerHTML]="entity.descriptionPt"></span>

                    <div class="clearfix"></div>

                    <button type="button" class="btn btn-outline-primary mt-3" (click)="toggleCompanyReadMore('PT')">
                      <span *ngIf="!companyReadMore.PT">{{'Read more' | translate}}</span>
                      <span *ngIf="companyReadMore.PT">{{'Read less' | translate}}</span>
                    </button>

                  </div>

                  <div id="company-read-more-pt" class="company-read-more" [class.d-none]="!companyReadMore.PT">

                    <div class="company-unique" *ngIf="entity.uniqueTextPt">
                      <h3>{{'What makes us so unique?' | translate}}</h3>
                      <span [innerHTML]="entity.uniqueTextPt"></span>
                    </div>

                    <div class="company-opportunities" *ngIf="entity.opportunitiesTextPt">
                      <h3>{{'Career possibilities' | translate}}</h3>
                      <span [innerHTML]="entity.opportunitiesTextPt"></span>
                    </div>

                  </div>

                </div>

              </div>



              <div class="company-photos mt-3" *ngIf="companyPhotos.length > 0">
                <h3>{{'Photos' | translate}}</h3>

                <div *ngIf="companyPhotos.length > 0">
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true">
                    <ng-template *ngFor="let slide of companyPhotos" ngbSlide>
                      <div class="slide-item flex-grow-1">
                        <div class="slide-item-wrapper" [ngStyle]="{'background-image' : 'url(' + slide['imageUri'] + ')'}">

                        </div>
                      </div>

                    </ng-template>
                  </ngb-carousel>
                </div>

              </div>

              <div class="company-videos mt-3" *ngIf="companyVideos.length > 0">

                <h3>{{'Videos' | translate}}</h3>

                <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true">
                  <ng-template *ngFor="let slide of companyVideos" ngbSlide>
                    <div class="slide-item flex-grow-1">
                      <a class="link-video cursor-pointer" (click)="videoService.openVideo(slide['youtubeUri'])">
                        <div class="slide-item-wrapper" [ngStyle]="{'background-image' : 'url(' + slide['youtubeImageUri'] + ')'}">

                        </div>
                      </a>
                    </div>

                  </ng-template>
                </ngb-carousel>

              </div>

            </div>

            <div id="tab-profile-jobs" class="tab-pane" [class.active]="activeTab === 'jobs'" [class.d-none]="activeTab !== 'jobs'">

              <h3 class="tab-title">{{'Jobs' | translate}}</h3>

              <div class="form-group">
                <div class="input-group">
                  <input (change)="applyFilterCompanyJobPostings()" [(ngModel)]="jobs.filters.search" type="text" [placeholder]="'Search by title...' | translate" class="form-control" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary" (click)="applyFilterCompanyJobPostings()">
                      <fa-icon [icon]="faSearch"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>

              <div class="form-group">

                <div class="custom-control custom-checkbox custom-control-inline" *ngFor="let type of jobTypes">
                  <input [checked]="existJobpostingType(type['value'])" type="checkbox" class="custom-control-input" />
                  <label class="custom-control-label" (click)="toggleJobpostingType(type['value'])">{{type['label'] | translate}}</label>
                </div>

              </div>

              <!-- results -->
              <div class="jobs" *ngIf="jobs.dataFiltered.length > 0">

                <div class="grid equal-height grid-jobs">

                  <div class="row">

                    <div class="col-12 col-lg-4 col-md-6 col-sm-6" *ngFor="let job of jobs.dataFiltered">
                      <app-job-card [roleType]="(userService.currentUserHasRole(RoleTypes.Student) ? RoleTypes.Student : '')" [data]="job"></app-job-card>
                    </div>

                  </div>

                </div>

              </div>

              <!-- no results -->
              <div *ngIf="jobs.dataFiltered.length == 0 || jobs.data.length == 0">
                <div class="alert alert-info">
                  {{'No results' | translate}}
                </div>
              </div>

            </div>

            <div id="tab-profile-assignments" class="tab-pane" [class.active]="activeTab === 'assignments'" [class.d-none]="activeTab !== 'assignments'">

              <h3 class="tab-title">{{'Assignments' | translate}}</h3>

              <div class="form-group">
                <div class="input-group">
                  <input (change)="applyFilterCompanyAssignments()" [(ngModel)]="assignments.filters.search" type="text" [placeholder]="'Search by title...' | translate" class="form-control" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary" (click)="applyFilterCompanyAssignments()">
                      <fa-icon [icon]="faSearch"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- results -->
              <div class="jobs" *ngIf="assignments.dataFiltered.length > 0">

                <div class="grid equal-height grid-jobs">

                  <div class="row">

                    <div class="col-12 col-lg-4 col-md-6 col-sm-6" *ngFor="let job of assignments.dataFiltered">
                      <app-job-card [roleType]="(userService.currentUserHasRole(RoleTypes.Student) ? RoleTypes.Student : '')" [isAssignment]="true" [data]="job"></app-job-card>
                    </div>

                  </div>

                </div>

              </div>

              <!-- no results -->
              <div *ngIf="assignments.dataFiltered.length == 0 || assignments.data.length == 0">
                <div class="alert alert-info">
                  {{'No results' | translate}}
                </div>
              </div>

            </div>

            <div id="tab-profile-experienceday" class="tab-pane" [class.active]="activeTab === 'experienceday'" [class.d-none]="activeTab !== 'experienceday'">

              <h3 class="tab-title">{{'Follow-up days' | translate}}</h3>

              <hr>

              <!-- results -->
              <div *ngIf="view.experiencedays.data.length > 0">

                <!-- results (open for registration) -->
                <div class="card mb-3" *ngFor="let experienceday of view.experiencedays.data">
                  <div class="card-header">
                    {{experienceday.title}}
                  </div>
                  <div class="card-body">

                    <div class="information">

                      <h5 class="">{{'Information' | translate}}</h5>

                      <div class="row" *ngIf="experienceday['minStudents']">
                        <div class="col-6">{{'Minimum amount of students' | translate}}</div>
                        <div class="col-6">{{experienceday['minStudents']}}</div>
                      </div>
                      <div class="row" *ngIf="experienceday['maxStudents']">
                        <div class="col-6">{{'Maximum amount of students' | translate}}</div>
                        <div class="col-6">{{experienceday['maxStudents']}}</div>
                      </div>

                      <div class="description mt-3" *ngIf="experienceday['description']" [innerHTML]="experienceday['description'] | safeHtml"></div>

                    </div>

                    <!-- possible dates to select for student -->
                    <div *ngIf="experienceday['possibleDates'].length > 0">

                      <h5>{{'Possible dates' | translate}}</h5>

                      <table class="table possible-dates mt-3">
                        <tbody>
                          <tr class="" *ngFor="let date of experienceday['possibleDates']">
                            <td class="date col-6">
                              {{date | date : "d-MM-YYYY"}}
                            </td>
                            <td class="action col-6 text-right">
                              <button class="btn btn-primary" *ngIf="userService.currentUserHasRole(RoleTypes.Student) && !experienceday.isCurrentUserRegistered" [disabled]="isProcessing" (click)="registerExperiencedayDate(experienceday, date)">
                                <fa-icon [icon]="faEdit"></fa-icon> {{'Register' | translate}}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>

                    <div class="btn-toolbar">
                      <button class="btn btn-secondary btn-block btn-sm" type="button" disabled *ngIf="experienceday.isCurrentUserRegistered && userService.currentUserHasRole(RoleTypes.Student)">
                        {{'You already registered' | translate}}
                      </button>
                    </div>

                  </div>
                </div>

                <!-- no results -->
                <div class="card" *ngIf="view.experiencedays.data.length == 0">
                  <div class="card-body">
                    <div class="alert alert-info">
                      {{'No results' | translate}}
                    </div>
                  </div>
                </div>

              </div>

              <!-- no results -->
              <div class="alert alert-info" *ngIf="view.experiencedays.data.length ==0">
                <span>{{'No results' | translate}}</span>
              </div>

            </div>

            <div id="tab-profile-trademarks" class="tab-pane" [class.active]="activeTab === 'trademarks'" [class.d-none]="activeTab !== 'trademarks'">

              <h3 class="tab-title">{{'Trade names' | translate}}</h3>

              <div class="results results-trademark">

                <div class="grid" *ngIf="companyTrademarks.length > 0">

                  <div class="row">
                    <div class="col-12 col-lg-4 col-sm-6" *ngFor="let trademark of companyTrademarks">

                      <div class="grid-item grid-item-network grid-item-network-company">
                        <div class="card">

                          <div [ngStyle]="{'background-image': 'url(' + trademark.coverPhotoUri +')' }" class="card-header grid-item-cover"></div>

                          <div class="card-body">

                            <div class="grid-item-profile-image">
                              <img class="card-img-top" [src]="(trademark.avatarUri ? trademark.avatarUri : avatarPlaceholder)" />
                            </div>
                            <h5 class="card-title grid-item-title">
                              {{trademark.name}}
                            </h5>

                            <div class="grid-item-body" *ngIf="trademark.description">
                              <span>{{trademark.description | striphtml | slice: 0:160}}</span>
                            </div>

                            <a class="btn-show-more cursor-pointer" *ngIf="trademark.description" (click)="showTrademarkDescription(trademark)">
                              {{'Show more' | translate}}
                            </a>

                          </div>


                        </div>
                      </div>


                    </div>
                  </div>

                </div>

              </div>

            </div>

            <div id="tab-profile-contact" class="tab-pane" [class.active]="activeTab === 'contact'" [class.d-none]="activeTab !== 'contact'">

              <h3>{{'Contact' | translate}}</h3>

              <table class="table">

                <tr *ngIf="entity.primaryContact && entity.primaryContact.firstName">
                  <td>
                    {{'Contact person' | translate}}
                  </td>
                  <td>
                    {{entity.primaryContact.firstName}} {{entity.primaryContact.lastName}}
                  </td>
                </tr>
                <tr *ngIf="entity.primaryContact && entity.primaryContact.emailAddress">
                  <td>
                    {{'Email address' | translate}}
                  </td>
                  <td>
                    {{entity.primaryContact.emailAddress}}
                  </td>
                </tr>


                <tr *ngIf="entity.phoneNumber">
                  <td>
                    {{'Phone number' | translate}}
                  </td>
                  <td>
                    {{entity.phoneNumber}}
                  </td>
                </tr>

                <tr *ngIf="entity.websiteUri">
                  <td>
                    {{'Website' | translate}}
                  </td>
                  <td>
                    <a target="_blank" [href]="entity.websiteUri">
                      {{entity.websiteUri}}
                    </a>
                  </td>
                </tr>

                <tr *ngIf="entity.facebookUri">
                  <td>
                    {{'Facebook'}}
                  </td>
                  <td>
                    <a target="_blank" [href]="entity.facebookUri">
                      {{entity.facebookUri}}
                    </a>
                  </td>
                </tr>

                <tr *ngIf="entity.linkedInUri">
                  <td>
                    {{'LinkedIn'}}
                  </td>
                  <td>
                    <a target="_blank" [href]="entity.linkedInUri">
                      {{entity.linkedInUri}}
                    </a>
                  </td>
                </tr>

                <tr *ngIf="entity.instagramUri">
                  <td>
                    {{'Instagram'}}
                  </td>
                  <td>
                    <a target="_blank" [href]="entity.instagramUri">
                      {{entity.instagramUri}}
                    </a>
                  </td>
                </tr>

                <tr *ngIf="entity.twitterUri">
                  <td>
                    {{'X (Twitter)'}}
                  </td>
                  <td>
                    <a target="_blank" [href]="entity.twitterUri">
                      {{entity.twitterUri}}
                    </a>
                  </td>
                </tr>

                <tr *ngIf="entity.visitAddress?.street">
                  <td>
                    {{'Address' | translate}}
                  </td>
                  <td>
                    {{entity.visitAddress?.street}} {{entity.visitAddress?.number}}{{entity.visitAddress?.numberSuffix ? '-' + entity.visitAddress?.numberSuffix : ''}}
                  </td>
                </tr>

                <tr *ngIf="entity.visitAddress.city">
                  <td>
                    {{'City' | translate}}
                  </td>
                  <td>
                    {{entity.visitAddress.city}}
                  </td>
                </tr>
                <tr *ngIf="entity.visitAddress.postalCode">
                  <td>
                    {{'Postal code' | translate}}
                  </td>
                  <td>
                    {{entity.visitAddress.postalCode}}
                  </td>
                </tr>
                <tr *ngIf="entity.visitAddress.country">
                  <td>
                    {{'Country' | translate}}
                  </td>
                  <td>
                    {{locale.getCountryName(entity.visitAddress.country)}}
                  </td>
                </tr>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
